import Navbar from './Navbar';
import Footer from './Footer';
import { Outlet } from 'react-router-dom';
import PageSEO from './PageSEO';

export default function Layout() {
  return (
    <div className="bg-cream-50 min-h-screen flex flex-col">
      <PageSEO />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
